import { useTestCaseContext } from '@Context/TestCaseContext';
import { CaretCircleDoubleLeft } from '@phosphor-icons/react';

const SidePanelButton = () => {
  const { setPanelOpen, viewType } = useTestCaseContext();
  return (
    <div className="absolute -right-5 top-1/2 -translate-y-1/2 transform">
      <button
        className={`${viewType === '' ? 'hidden' : ''} rounded-3xl border border-gray-500 bg-white text-primary-700 shadow-lg transition-transform duration-200 hover:scale-125 hover:shadow-xl`}
        onClick={() => setPanelOpen(true)}
        aria-label="Open Side Panel"
      >
        <CaretCircleDoubleLeft size={70} weight="fill" />
      </button>
    </div>
  );
};

export default SidePanelButton;
